import { render, staticRenderFns } from "./SizeChart.vue?vue&type=template&id=e9c10584&"
import script from "./SizeChart.vue?vue&type=script&lang=js&"
export * from "./SizeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports